<template>
    <div class="ma-5 d-flex align-items-center" cols="6">
        <input-select :setup.sync="category"></input-select>
        <div class="align-self-center">
            <v-btn
                color="error"
                class="mr-1"
                text
                small
                @click="clearFilters"
            >{{ $t('common.filter.clearFilter') }}</v-btn>
            <v-btn
                color="primary"
                class="ml-1"
                small
                @click="applyFilters"
            >{{ $t('common.filter.applyFilter') }}</v-btn>
        </div>
        </div>
</template>

<script>
import InputSelect from '@/components/InputSelect'

export default {
    name: 'timeline-filter',
    components: {
        InputSelect
    },
    data () {
        return {
            collapse: 1,
            ready: false,
            category: {
                label: this.$t('common.timeline.category.labelFilter'),
                text: 'label',
                value: 'value',
                icon: 'feedback',
                multiple: true,
                clearable: true,
                items: [
                    { value: 1, label: this.$t('common.timeline.category.items.noteFile') },
                    { value: 2, label: this.$t('common.timeline.category.items.meeting') },
                    { value: 3, label: this.$t('common.timeline.category.items.phone') },
                    { value: 4, label: this.$t('common.timeline.category.items.email') },
                    { value: 6, label: this.$t('common.timeline.category.items.charge') }
                ],
                selectedItems: []
            }
        }
    },
    methods: {
        applyFilters () {
            this.$emit('filter-timeline', this.category.selectedItems, true)
        },
        clearFilters () {
            this.category.selectedItems = []
            this.$emit('filter-timeline', null, true)
        },
        selectAction: function (vm) {
            return (vm.selectedItems.length !== vm.items.length) ? this.$t('common.checkAll') : this.$t('common.uncheckAll')
        },
        toggleSelectItemStatus (select) {
            this.$nextTick(() => {
                if (select.selectedItems.length === select.items.length) {
                    select.selectedItems = []
                } else {
                    select.items.forEach((item) => {
                        if (select.selectedItems.indexOf(item.value) === -1) {
                            select.selectedItems.push(item.value)
                        }
                    })
                }
            })
        }
    }
}
</script>
